var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "      <div class=\"required-view\">\n        <input type=\"checkbox\" disabled=\"disabled\" checked=\"checked\">&nbsp;Required\n        <div>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.requiredText : stack1), depth0))
    + "</div>\n      </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "      <div class=\"optional-view\">\n        <input type=\"checkbox\" disabled=\"disabled\">&nbsp;Not Required\n      </div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"markdown-description\">\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.markdown_description : stack1), depth0)) != null ? stack1 : "")
    + "\n    </div>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"assoc-resource-heading\">\n      <div class=\"assoc-resource-title h5\">Tools</div>\n      <div class=\"assoc-resource-logo\">\n          <img src=\"https://i.imgur.com/3GY3fNr.png\"/>\n      </div>\n    </div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.tools : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <hr/>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("/Users/niall/projects/workflows-js/src/templates/view_mode/_tool_card.hbs"),depth0,{"name":"_tool_card","data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"assoc-resource-heading\">\n      <div class=\"h5\">Relevant Training Resources</div>\n\n      <div class=\"assoc-resource-logo\">\n          <img src=\"https://tess.elixir-europe.org/assets/ELIXIR_TeSS_logo_normal-727bfde348524693ee8bee7a4f6c38f2d2633f6496c996f6fde297d6251ce8a8.png\"/>\n      </div>\n    </div>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.trainings : depth0),{"name":"each","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <hr/>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("/Users/niall/projects/workflows-js/src/templates/view_mode/_training_card.hbs"),depth0,{"name":"_training_card","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"h5\">Opeartion Terms</div>\n      <div class=\"terms\">\n        <div class=\"term\">\n          <div class=\"term-heading\">\n            <div class=\"term-name\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.custom : stack1), depth0))
    + "</div>\n          </div>\n        </div>\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"h5\">Operation Terms</div>\n      <div class=\"terms\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.terms : depth0)) != null ? stack1["0"] : stack1),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(27, data, 0),"data":data})) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.terms : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "          <div class=\"term\">\n            <div class=\"term-heading\">\n              <div class=\"term-name\" id='"
    + alias2(alias1((depth0 != null ? depth0["0"] : depth0), depth0))
    + "'>"
    + alias2(alias1((depth0 != null ? depth0["2"] : depth0), depth0))
    + "</div>\n              <div class=\"ontology\">\n                <a href=\"http://identifiers.org/edam:operation_"
    + alias2(alias1((depth0 != null ? depth0["1"] : depth0), depth0))
    + "\"\n                  target=\"_blank\">\n                edam:operation_"
    + alias2(alias1((depth0 != null ? depth0["1"] : depth0), depth0))
    + "</a>\n                </div>\n            </div>\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0["3"] : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0["4"] : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "          </div>\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "              Synonyms:\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0["3"] : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"19":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                <span class=\"term-synonym\">\n                  "
    + container.escapeExpression(container.lambda(depth0, depth0))
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(data && data.last),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data})) != null ? stack1 : "")
    + "\n                </span>\n";
},"20":function(container,depth0,helpers,partials,data) {
    return "";
},"22":function(container,depth0,helpers,partials,data) {
    return ",";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "              <hr/>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0["4"] : depth0),{"name":"each","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"25":function(container,depth0,helpers,partials,data) {
    return "                <div class=\"term-description\">"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</div>\n";
},"27":function(container,depth0,helpers,partials,data) {
    return "          There are no Operation terms annotated for this step\n          <hr/>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class='node-view'>\n  \n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.required : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "  \n\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.markdown_description : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  <hr/>\n\n\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.tools : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    \n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.trainings : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "  \n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.data : depth0)) != null ? stack1.custom : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data})) != null ? stack1 : "")
    + "  </div>  \n    \n</div>\n\n";
},"usePartial":true,"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/view_mode/operation.hbs
// module id = 144
// module chunks = 0